// Master JS for Signup page

/* global grecaptcha, RECAPTCHA_KEY, FB */

import { WireupHandlers, SetElementsVisible, SetLoadingState } from "./lib/data-wireup.js";
import { PostJSON } from "./lib/fetchers.js";
import { FormToObject } from "./lib/form-utilities.js";

import { SubmitStatus } from "./webcomponents/submit-status.js";

// Register required webcomponents
SubmitStatus.Register();

// Hang onto email/signature for use on page 2
let email, signature;
let isResend = false;

window.onReCaptcha = function () {
    grecaptcha.render("recaptcha-container", {
        "sitekey": RECAPTCHA_KEY,
        "callback": onReCaptchaSubmit,
        "expired-callback": onReCaptchaExpire,
        "error-callback": onReCaptchaError,
        "size": "invisible"
    });
};

WireupHandlers("facebook", "click", async (e) => {
    e.preventDefault();
    FB.login(async function (response) {
        if (response.status == "connected" && response.authResponse) {
            try {
                let returnFragment = "";
                if (window.ReturnUrl) returnFragment = "&ReturnUrl=" + encodeURIComponent(window.ReturnUrl);
                const result = await PostJSON("/users/sign_in_fb/?access_token=" + response.authResponse.accessToken + returnFragment);
                window.location = result.returnUrl;
            } catch (err) {
                SubmitStatus.Set("email-status", err.message, true);
            }
        }
    }, { scope: "public_profile,email" });
});

// Main form submit
// Note: we don't set the button loading state here because we have to wait until after recaptcha processes, in case they click out
WireupHandlers("signup", "submit", async () => {
    SubmitStatus.Hide("email-status");
    isResend = false;
    // Kick off captcha verification
    await grecaptcha.execute();
});

// Resend email
WireupHandlers("resend", "click", async () => {
    SubmitStatus.Set("code-status", "Resending code...", false, true);
    isResend = true;
    // Kick off captcha verification
    await grecaptcha.execute();
});

// Return to previous page
WireupHandlers("page1", "click", async () => {
    SetElementsVisible("entercode", false);
    SetElementsVisible("signup", true);
});


function onReCaptchaExpire() {
    grecaptcha.reset();
    SetLoadingState("signupsubmit", false);
    SubmitStatus.Hide("code-status");
}


function onReCaptchaError() {
    grecaptcha.reset();
    SetLoadingState("signupsubmit", false);
    SubmitStatus.Set("code-status", "The action did not complete. Please try again.", true);
}

/**
 * On recaptcha success, submit the email
 */
async function onReCaptchaSubmit(token) {
    try {
        // Always reset the captcha in case they resend or go back and send to another email
        grecaptcha.reset();
        SetLoadingState("signupsubmit", true);
        SubmitStatus.Hide("code-status");
        const form = document.querySelector("[data-wireup-signup]");
        const formData = FormToObject(form);
        formData.token = token;
        // Save for page 2 if needed
        email = formData.Email;
        const result = await PostJSON("/users/sign_up", formData);
        if (result.signature) {
            signature = result.signature;
            // Populate and show page 2
            SetElementsVisible("signup", false);
            SetElementsVisible("entercode", true);
            // Focus to the code input
            const field = document.getElementById("signinCode");
            field.focus();
            if (isResend) {
                SubmitStatus.Set("code-status", "A new code was sent to " + email, false);
            } else {
                SubmitStatus.Set("code-status", "We sent an email to " + email, false);
            }
        } else if (result.returnUrl) {
            window.location = result.returnUrl;
        }
    } catch (err) {
        console.error(err);
        SubmitStatus.Set("email-status", err.message, true, false, true);
    } finally {
        SetLoadingState("signupsubmit", false);
    }
}

// Code form submit
WireupHandlers("entercode", "submit", async () => {
    SubmitStatus.Hide("code-status");

    try {
        const form = document.querySelector("[data-wireup-entercode]");
        const formData = FormToObject(form);
        const returnUrl = new URLSearchParams(window.location.search).get("ReturnUrl");
        const result = await PostJSON("/users/sign_up_email_verify", { email, code: formData.code, signature, returnUrl });
        window.location = result.returnUrl;
        return true;
    } catch (err) {
        console.error(err);
        let message = err.message;
        // Override with more descriptive message
        if (message === "An invalid code was entered.") {
            message = "An invalid code was entered.\n\nCodes expire after 15 minutes, 3 incorrect tries, or upon requesting a new code.\n\nPlease recheck your code or check your email for a more recent code."
        }
        SubmitStatus.Set("code-status", message, true);
    }
}, "codesubmit");
